function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import classnames from 'classnames';
import React from 'react';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import { Breakpoints } from "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import { TableLooks } from "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { Caption } from "./caption.js";
import { StandardTBody } from "./standard-tbody.js";
import { Table } from "./table.js";
import { Td } from "./td.js";
import { TFoot } from "./tfoot.js";
import { Th } from "./th.js";
import { THead } from "./thead.js";
import { Tr } from "./tr.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var StandardTable = function StandardTable(props) {
  var _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [Breakpoints.Sm] : _props$breakpoints,
    caption = props.caption,
    captionProps = props.captionProps,
    colGroup = props.colGroup,
    columns = props.columns,
    empty = props.empty,
    emptyContent = props.emptyContent,
    emptyTrProps = props.emptyTrProps,
    error = props.error,
    errorContent = props.errorContent,
    errorTrProps = props.errorTrProps,
    footer = props.footer,
    footerContent = props.footerContent,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? true : _props$hover,
    id = props.id,
    _props$loaderLabel = props.loaderLabel,
    loaderLabel = _props$loaderLabel === void 0 ? '' : _props$loaderLabel,
    loaderTrProps = props.loaderTrProps,
    loading = props.loading,
    _props$look = props.look,
    look = _props$look === void 0 ? TableLooks.Default : _props$look,
    maxHeight = props.maxHeight,
    rows = props.rows,
    _props$scrollX = props.scrollX,
    scrollX = _props$scrollX === void 0 ? true : _props$scrollX,
    scrollY = props.scrollY,
    showCaption = props.showCaption,
    tableProps = props.tableProps,
    tbodyProps = props.tbodyProps,
    tdProps = props.tdProps,
    tfootProps = props.tfootProps,
    thProps = props.thProps,
    theadProps = props.theadProps,
    trProps = props.trProps;
  var columnsLength = columns.length;
  var rowsLength = rows.length;
  var isEmpty = empty !== null && empty !== void 0 ? empty : rowsLength === 0;
  return /*#__PURE__*/React.createElement(Table, _extends({}, tableProps, {
    breakpoints: breakpoints,
    empty: isEmpty,
    error: error,
    footer: footer,
    hover: hover,
    id: id,
    loading: loading,
    look: look,
    maxHeight: maxHeight,
    scrollX: scrollX,
    scrollY: scrollY
  }), /*#__PURE__*/React.createElement(Caption, _extends({}, captionProps, {
    breakpoints: breakpoints,
    showCaption: showCaption
  }), caption), colGroup && colGroup, /*#__PURE__*/React.createElement(THead, _extends({}, theadProps, {
    breakpoints: breakpoints
  }), /*#__PURE__*/React.createElement(Tr, _extends({}, trProps, {
    breakpoints: breakpoints,
    look: look
  }), columns.map(function (column, columnIndex) {
    return /*#__PURE__*/React.createElement(Th, _extends({}, thProps, {
      breakpoints: breakpoints,
      key: "".concat(id, "-th-").concat(columnIndex),
      centered: column.centered,
      scope: "col",
      style: {
        maxWidth: column.maxWidth,
        minWidth: column.minWidth,
        width: column.width
      },
      title: column.headingTitle
    }), column.children);
  }))), /*#__PURE__*/React.createElement(StandardTBody, _extends({}, tbodyProps, {
    breakpoints: breakpoints,
    columnsLength: columnsLength,
    empty: isEmpty,
    emptyContent: emptyContent,
    emptyTrProps: emptyTrProps,
    error: error,
    errorContent: errorContent,
    errorTrProps: errorTrProps,
    loaderLabel: loaderLabel,
    loaderTrProps: loaderTrProps,
    loading: loading
  }), rows.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement(Tr, _extends({}, trProps, {
      breakpoints: breakpoints,
      key: "".concat(id, "-tr-").concat(rowIndex),
      look: look
    }), columns.map(function (column, columnIndex) {
      var _classnames;
      return /*#__PURE__*/React.createElement(Td, _extends({}, tdProps, {
        className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(column.tdClassName), !!column.tdClassName), _defineProperty(_classnames, "".concat(tdProps === null || tdProps === void 0 ? void 0 : tdProps.className), !!(tdProps !== null && tdProps !== void 0 && tdProps.className)), _classnames)),
        key: "".concat(id, "-td-").concat(columnIndex),
        breakpoints: breakpoints,
        centered: column.centered,
        ellipsis: column.ellipsis,
        heading: column.heading,
        style: {
          maxWidth: column.maxWidth,
          minWidth: column.minWidth,
          width: column.width
        },
        title: column.cellTitle
      }), row[column.rowKey]);
    }));
  })), footer && footerContent && /*#__PURE__*/React.createElement(TFoot, _extends({}, tfootProps, {
    breakpoints: breakpoints
  }), /*#__PURE__*/React.createElement(Tr, _extends({}, trProps, {
    breakpoints: breakpoints,
    look: look
  }), /*#__PURE__*/React.createElement(Td, _extends({}, tdProps, {
    breakpoints: breakpoints,
    colSpan: columnsLength
  }), footerContent))));
};
export { StandardTable };